module.exports = __webpack_public_path__ + "img/user-portada.da58dc64.jpg";